import {ReactNode} from 'react';
import {selectIsSaleStateIng} from '../../../../common/selectIsSaleStateIng';
import {
  PurchaseType,
  ReadAccessType,
} from '../../../../graphql/generated/types';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useSinglePreviewQuery} from '../../../../wrapper';
import {
  useContentHomeOverviewQuery,
  useSimpleSeriesSingleInfoQuery,
} from '../../../../wrapper/contentWrapper';
import {useViewerInfoQuery} from '../../../../wrapper/viewerWrapper';

export interface ContentSaleStateCheckerHeadlessProps {
  seriesId: number;
  /**
   * 뷰어에 접근한 경우에도 동일한 로직으로 판매중지를 체크합니다
   */
  productId?: number;
  /**
   * 판매중일 땐 children 을 보여줍니다
   */
  children?: ReactNode;
  /**
   * 판매중이 아닐 땐 ifStop 의 컴포넌트를 보여줍니다
   */
  ifStop?: ReactNode;
}

export function ContentSaleStateCheckerHeadless({
  seriesId,
  productId,
  children,
  ifStop,
}: ContentSaleStateCheckerHeadlessProps) {
  const contentHomeData = useContentHomeOverviewQuery(
    {seriesId},
    ONLY_DATA_CONFIG
  ).data;
  const singleSimpleData = useSimpleSeriesSingleInfoQuery(
    {
      seriesId,
      productId,
    },
    ONLY_DATA_CONFIG
  ).data;

  const isSaleStateIng = selectIsSaleStateIng({
    data: contentHomeData,
    singleSimpleData,
    productId,
  });

  const singlePreviewResult = useSinglePreviewQuery(
    // @ts-ignore
    {productId},
    {enabled: productId !== undefined}
  );
  const {data: singlePreviewData} = singlePreviewResult;

  const singleReadAccessType = singlePreviewData?.singlePreview?.readAccessType;

  const viewerInfo = useViewerInfoQuery(
    // @ts-ignore
    {seriesId, productId},
    ONLY_DATA_CONFIG
  ).data;
  const purchaseInfo = viewerInfo?.item?.serviceProperty?.purchaseInfo;

  const canEnter =
    isSaleStateIng ||
    // 구매 중지한 경우여도 대여/소장한 경우 보여줍니다
    (purchaseInfo &&
      (purchaseInfo.purchaseType === PurchaseType.Buy ||
        (purchaseInfo.purchaseType === PurchaseType.Rent &&
          !purchaseInfo.expired))) ||
    singleReadAccessType === ReadAccessType.CanRead;

  if (canEnter) {
    return <>{children}</>;
  } else {
    return <>{ifStop}</>;
  }
}
